import axios from '@/axios'
import * as types from '../mutation-types'

export default {
    namespaced: true,

    state: {
        evaluationsTypes: []
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/evaluation').then(({ data }) => {
                commit(types.STORE_EVALUATIONS_TYPES, data);
                return data;
            });
        },
    },

    mutations: {
        [types.STORE_EVALUATIONS_TYPES](state, evaluationsTypes) {
            state.evaluationsTypes = evaluationsTypes;
        }
    },

    getters: {
        getEvaluationsTypeById: state => id => state.evaluationsTypes.find(c => c.id === id)
    }
}